/**
 * Prior to 8.0, the seed project contained its own UIComponents.json file. The names of components within this file
 * weren't standardized around capitalization and spaces. This object maps the old names to the new standardized names.
 *
 * The new standardized names are referenced by internal Finsemble code. Finsemble expects these components to exist,
 * therfore this mapping is used to convert legacy component entries to their expected names. This is done in the config
 * service.
 *
 * Meanwhile, legacy customer code may still be programmed to the old names, such as calling LauncherClient.spawn(),
 * LauncherClient.showWindow(), LauncherClient.getActiveDescriptors(), or DialogManager.show(). Those functions also
 * therefore utilize this mapping to launch or display the appropriate component.
 *
 * Note, NonConfiguredComponent should _not_ be converted because the legacy "unknownComponent" config has a lowercase entry.
 */
export const nameMap = {
	fdc3Resolver: "FDC3Resolver",
	linkerWindow: "LinkerWindow",
	"Docking Move Mask": "DockingGroupMask",
	yesNo: "YesNoDialog",
	singleInput: "SingleInputDialog",
	"Process Monitor": "ProcessMonitor",
	"Advanced App Catalog": "AppCatalog",
};
